import React, { FunctionComponent } from "react";

export const NotFound: FunctionComponent = () => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center p-6 text-center">
      <p className="text-6xl font-bold text-gray-300">404</p>
      <h1 className="mt-4">Not Found</h1>
      <p className="mt-2 text-gray-600">
        Sorry, the page you are looking for does not exist.
      </p>
    </div>
  );
};

/**
 * @see docs/worklog/TW-632-cms-enable-retail-site-flag/rfc.md
 */
